import getSessionAuditJSON from '../../../shared/api/sessionAudit/sessionAudit.js';
import { renderOtp } from '../form/otp/renderOtp.js';
import { ERROR_CREDENTIALS, ERROR_TYPES } from '../form/renderError.js';

export const AUTH_ERROR = {
  WRONG_DOMAIN: 2,
  WRONG_ACCESS_CREDENTIALS: 6,
  USER_DISABLED: 14,
  OTP_REQUIRED: 36,
  OTP_INVALIDCODE: 37,
};

// 07/2023 Nuevo registerSession con OTP (Node)
export async function registerSession(viewdocsForm) {
  let response;

  const params = {
    user: viewdocsForm.user,
    password: viewdocsForm.password,
    domain: viewdocsForm.domain,
    group: viewdocsForm.group,
  };

  params.audit = getSessionAuditJSON(params);
  params.seccode = getOtpToken(viewdocsForm);

  try {
    response = await fetch('/connect/registerSession', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify(params),
    });
  } catch (e) {
    console.error(e);
    throw e;
  }

  // Control de errores
  if (!response.ok) {
    const { code = AUTH_ERROR.WRONG_ACCESS_CREDENTIALS } = await response.json();

    // handleErrors: lo dejamos preparado por si no detectamos authOtpRequired (dejan de enviar bt)
    if (!viewdocsForm.authOtpRequired && code === AUTH_ERROR.OTP_REQUIRED) {
      viewdocsForm.authOtpRequired = true;
      renderOtp(null, viewdocsForm);
      return null; // no token + no error
    }

    // El resto acaban en mensaje de error
    throw new Error(getAuthError(code));
  }

  try {
    const data = await response.json();
    const { tokena } = data;

    // Comprobación registerSession sin otp, pero vemos que se necesita para el print
    if (viewdocsForm.printOtpRequired && !params.seccode) {
      renderOtp(tokena, viewdocsForm);
      return null;
    } else {
      return tokena;
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}

function getOtpToken(viewdocsForm) {
  return viewdocsForm.authOtpRequired ? viewdocsForm.seccode : '';
}

// Podemos personalizar los credentials error que hagan falta dándolos de alta:
// ErrorTypes.CREDENTIAL_{{AUTH_ERROR}}: "error{{número de entrada en el translation}}"
// (OTP_NOT_CONFIGURED, ENROLLMENT_REQUIRED, PASSWORD_EXPIRED)
function getAuthError(authError) {
  switch (authError) {
    case AUTH_ERROR.WRONG_DOMAIN:
    case AUTH_ERROR.USER_DISABLED:
      return 'INVALID';
    default: {
      // ERROR_CREDENTIALS -> Se permite reintento
      const credentialsError = `${ERROR_CREDENTIALS}_${authError}`; // -> Nunca se podrá loguear el usuario
      return ERROR_TYPES.hasOwnProperty(credentialsError) ? credentialsError : ERROR_CREDENTIALS;
    }
  }
}
